import { Box, Text } from '@wix/design-system';
import { useIsStudioNewUi } from '@wix/package-picker-shared-studio';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import {
  CreativeOffer,
  PurchaseOffering,
} from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './FeaturesGrid.scss';
import { FeaturesGridFeatureRow } from './FeaturesGridFeatureRow';

interface FeaturesGridGroupProps {
  group: CreativeOffer.GridNamespace;
  products?: PurchaseOffering.PurchaseProduct[];
  recommendedProductId?: string;
}

export const FeaturesGridGroup = ({
  group,
  products,
  recommendedProductId,
}: FeaturesGridGroupProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();

  return (
    <PlatformFeaturesGrid.Content.Group
      className={isStudioNewUi ? s.featureGroup : undefined}
      groupHeaderClassName={isStudioNewUi ? s.featureGroupHeader : s.groupHeader}
      header={
        <Box>
          <Text
            weight="bold"
            size={isStudioNewUi ? 'small' : undefined}
            className={isStudioNewUi ? s.featureGroupTitle : undefined}
          >
            {t(group.content?.name?.translationKey ?? '')}
          </Text>
        </Box>
      }
      collapsible
      labels={{
        open: t('studio_package_picker.show_features'),
        close: t('studio_package_picker.close_features'),
      }}
      onToggle={(action) => {
        StudioPackagePickerModule.internals.bi.onToggleFeatureGroup?.({
          groupKey: group.content?.name?.translationKey,
          action,
        });
      }}
    >
      {group.features?.map((feature) => (
        <FeaturesGridFeatureRow
          key={feature.id}
          feature={feature}
          products={products}
          recommendedProductId={recommendedProductId}
        />
      ))}
    </PlatformFeaturesGrid.Content.Group>
  );
};
